<template>
  <div class="page-content degree-apply-result">
    <div class="page-header">
      <div class="page-header-line"></div>
      <h5 @click="reviewDialogVisible=true">学位申请</h5>
    </div>

    <div class="page-body">
      <!-- 批次与状态 -->
      <div class="batch-row">
        <div class="batch-item">
          <span class="field-label">学位申请批次：</span>
          <el-select
            v-model="batchId"
            placeholder="请选择学位申请批次"
            class="batch-select"
            @change="onBatchChange"
          >
            <el-option
              v-for="item in batchOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="batch-item batch-time">
          <span class="field-label">学术复核时间：</span>
          <span class="field-value">{{ academicReviewTimeText }}</span>
        </div>
      </div>

      <div class="status-row">
        <span class="field-label">状态：</span>
        <span class="status-text" :class="statusClass">{{ statusText }}</span>
        <el-button
          v-if="showAcademicReviewBtn"
          type="primary"
          size="small"
          class="review-btn"
          @click="openReviewDialog"
        >学术复核申请</el-button>
      </div>

      <div v-if="academicReviewTip" class="time-tip">{{ academicReviewTip }}</div>

      <div class="divider"></div>

      <!-- 学术复核（已申请时展示） -->
      <template v-if="academicReview">
        <div class="section-title">学术复核</div>
        <div class="info-card">
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">学术复核申请时间：</span>
              <span class="info-value">{{ academicReview.submitTime || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">复核申请表：</span>
              <a
                v-if="academicReview.studentApplyFormUrl"
                class="file-link"
                :href="academicReview.studentApplyFormUrl"
                target="_blank"
              >{{ academicReview.studentApplyFormName || '复核申请表' }}</a>
              <span v-else class="info-value">—</span>
            </div>
            <div class="info-item">
              <span class="info-label">复核结果：</span>
              <a
                v-if="academicReview.teacherDecisionUrl"
                class="file-link"
                :href="academicReview.teacherDecisionUrl"
                target="_blank"
              >{{ academicReview.teacherDecisionName || '复核决定书' }}</a>
              <span v-else class="info-value status-text status-pending">待复核</span>
            </div>
          </div>
        </div>
      </template>

      <!-- 学位课程成绩与考籍表 -->
      <div class="section-title">学位课程成绩与考籍表</div>
      <div class="info-card">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">学位课程平均成绩：</span>
            <span class="info-value">{{ detail.examAvgScore || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">考籍表材料：</span>
            <a
              v-if="detail.studentStatusProofUrl"
              class="file-link"
              :href="detail.studentStatusProofUrl"
              target="_blank"
            >{{ detail.studentStatusProofName || '考籍表材料' }}</a>
            <span v-else class="info-value">—</span>
          </div>
        </div>
      </div>

      <!-- 学位外语成绩 -->
      <div class="section-title">学位外语成绩</div>
      <div class="info-card">
        <div class="info-grid">
          <template v-if="detail.eflSource === 2">
            <div class="info-item">
              <span class="info-label">成果获取时间：</span>
              <span class="info-value">{{ detail.eflExamDate || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">成绩证明材料：</span>
              <a
                v-if="detail.achievementProofUrl"
                class="file-link"
                :href="detail.achievementProofUrl"
                target="_blank"
              >{{ detail.achievementProofName || '成绩证明材料' }}</a>
              <span v-else class="info-value">—</span>
            </div>
          </template>
          <template v-else>
            <div class="info-item">
              <span class="info-label">外语类型：</span>
              <span class="info-value">{{ eflTypeText }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">学位外语成绩：</span>
              <span class="info-value">{{ detail.eflScore || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">学位外语证号：</span>
              <span class="info-value">{{ detail.eflCertificateNo || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">考试时间：</span>
              <span class="info-value">{{ detail.eflExamDate || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">成绩证明材料：</span>
              <a
                v-if="detail.achievementProofUrl"
                class="file-link"
                :href="detail.achievementProofUrl"
                target="_blank"
              >{{ detail.achievementProofName || '成绩证明材料' }}</a>
              <span v-else class="info-value">—</span>
            </div>
            <div class="info-item">
              <span class="info-label">考试地点：</span>
              <span class="info-value">{{ detail.eflExamAddress || '—' }}</span>
            </div>
          </template>
        </div>
      </div>

      <!-- 论文 -->
      <div class="section-title">论文</div>
      <div class="info-card">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">论文题目：</span>
            <span class="info-value">{{ detail.thesisTitle || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">查重率：</span>
            <span class="info-value">{{ plagiarismRateText }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">论文稿件：</span>
            <a
              v-if="detail.thesisManuscriptUrl"
              class="file-link"
              :href="detail.thesisManuscriptUrl"
              target="_blank"
            >{{ detail.thesisManuscriptName || '论文稿件' }}</a>
            <span v-else class="info-value">—</span>
          </div>
          <div class="info-item">
            <span class="info-label">查重报告：</span>
            <a
              v-if="detail.plagiarismReportUrl"
              class="file-link"
              :href="detail.plagiarismReportUrl"
              target="_blank"
            >{{ detail.plagiarismReportName || '查重报告' }}</a>
            <span v-else class="info-value">—</span>
          </div>
          <div class="info-item">
            <span class="info-label">其他附件：</span>
            <a
              v-if="detail.otherAttachmentUrl"
              class="file-link"
              :href="detail.otherAttachmentUrl"
              target="_blank"
            >{{ detail.otherAttachmentName || '其他附件' }}</a>
            <span v-else class="info-value">—</span>
          </div>
          <div class="info-item">
            <span class="info-label">电子照片：</span>
            <a
              v-if="detail.electronicPhotoUrl"
              class="file-link"
              :href="detail.electronicPhotoUrl"
              target="_blank"
            >{{ detail.electronicPhotoName || '电子照片' }}</a>
            <span v-else class="info-value">—</span>
          </div>
        </div>
      </div>

      <!-- 日志 -->
      <div class="section-title">日志</div>
      <div class="audit-timeline">
        <div
          v-for="(item, index) in logs"
          :key="index"
          class="audit-timeline-item"
        >
          <span class="timeline-dot"></span>
          <span v-if="index < logs.length - 1" class="audit-timeline-line"></span>
          <div class="audit-log-card">
            <div class="audit-log-header">
              <div class="audit-field">
                <span class="audit-label">操作时间：</span>
                <span class="audit-value">{{ item.createTime || item.operTime || '—' }}</span>
              </div>
              <div class="audit-field">
                <span class="audit-label">操作人：</span>
                <span class="audit-value">{{ item.operatorName || item.operName || '—' }}</span>
              </div>
              <div class="audit-field">
                <span class="audit-label">状态：</span>
                <span class="audit-status-wrap">
                  <template v-if="hasStatusChange(item)">
                    <span class="audit-status" :class="getStatusClass(item.beforeStatus, item)">{{ getStatusLabel(item.beforeStatus, item) }}</span>
                    <span class="audit-status-arrow">→</span>
                    <span class="audit-status" :class="getStatusClass(getAfterStatus(item), item)">{{ getStatusLabel(getAfterStatus(item), item) }}</span>
                  </template>
                  <span
                    v-else
                    class="audit-status"
                    :class="getLogStatusClass(item)"
                  >{{ getLogStatusText(item) }}</span>
                </span>
              </div>
            </div>
            <div class="audit-log-remark">
              <span class="audit-label">操作描述：</span>
              <span class="audit-value">{{ item.operDesc }}</span>
            </div>
            <div class="audit-log-remark" v-if="item.operRemark">
              <span class="audit-label">审核意见：</span>
              <span class="audit-value">{{ item.operRemark }}</span>
            </div>
          </div>
        </div>
        <div v-if="!logs.length" class="empty-log">暂无日志</div>
      </div>
    </div>

    <!-- 学术复核弹窗 -->
    <el-dialog
      title="学术复核"
      :visible.sync="reviewDialogVisible"
      width="560px"
      custom-class="academic-review-dialog"
      :close-on-click-modal="false"
      @closed="resetReviewForm"
    >
      <div class="review-dialog-body">
        <div class="review-row">
          <span class="review-label">学术复核申请表模板：</span>
          <a class="file-link" href="javascript:;" @click.prevent="downloadTemplate">下载学术复核申请表模板.docx</a>
        </div>
        <div class="review-row">
          <span class="review-label required">上传学术复核申请表扫描件：</span>
          <UploadImage
            mode="button"
            button-text="上传扫描件"
            accept=".jpg,.jpeg,.png"
            v-model="reviewForm.fileUrl"
            @success="onReviewImageSuccess"
          />
          <span class="upload-tip">支持.jpg,.jpeg,.png格式</span>
        </div>
        <a
          v-if="reviewForm.fileName"
          class="file-link review-file-name"
          :href="reviewForm.fileUrl"
          target="_blank"
        >{{ reviewForm.fileName }}</a>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="review-btn-cancel" @click="reviewDialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" :loading="reviewSubmitting" @click="submitReview" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  degreeAcademicReviewStatus,
  degreeApplyFinalStatus,
  degreeApplyStatus,
  degreeEflType,
  degreeThesisEnrollStatus,
} from '@/utils/enums'

export default {
  name: 'DegreeApplyResult',
  components: {
    UploadImage: () => import('@/components/UploadImage.vue'),
  },
  data() {
    return {
      batchId: '',
      batchOptions: [],
      currentBatch: null,
      enrollId: '',
      // 资料审核状态：0待初审 1待终审 2通过 3暂不通过 5不通过
      status: null,
      // 论文审核状态 enrollStatus：4待资格通过 0待论文评审 1打回修改 2通过 5不通过
      enrollStatus: null,
      // 最终结论 degreeApplyStatus：1通过 0不通过
      degreeApplyResult: null,
      detail: {},
      logs: [],
      academicReview: null,
      reviewDialogVisible: false,
      reviewSubmitting: false,
      reviewForm: {
        fileUrl: '',
        fileName: '',
      },
    }
  },
  computed: {
    academicReviewTimeText() {
      const b = this.currentBatch
      if (!b || (!b.academicReviewStart && !b.academicReviewEnd)) return '—'
      return `${b.academicReviewStart || ''} 至 ${b.academicReviewEnd || ''}`
    },
    /** 学术复核申请窗口；起止均未配置则不限制 */
    isInAcademicReviewTime() {
      const b = this.currentBatch
      if (!b || (!b.academicReviewStart && !b.academicReviewEnd)) return true
      const now = Date.now()
      if (b.academicReviewStart && now < this.$utils.toTime(b.academicReviewStart)) return false
      if (b.academicReviewEnd && now > this.$utils.toTime(b.academicReviewEnd)) return false
      return true
    },
    academicReviewTip() {
      if (this.status === 5 || this.academicReview || this.enrollStatus !== 5) return ''
      if (!this.isInAcademicReviewTime) {
        return `学术复核时间为 ${this.academicReviewTimeText}，当前不在申请时间范围内`
      }
      return ''
    },
    statusText() {
      if (this.degreeApplyResult != null) {
        const key = String(this.degreeApplyResult)
        return degreeApplyFinalStatus[key] != null ? degreeApplyFinalStatus[key] : key
      }
      if (this.status === 2 && this.enrollStatus != null) return this.enrollStatusText
      if (this.status == null) return '—'
      const key = String(this.status)
      return degreeApplyStatus[key] != null ? degreeApplyStatus[key] : key
    },
    statusClass() {
      if (this.degreeApplyResult === 0) return 'status-fail'
      if (this.degreeApplyResult === 1) return 'status-pass'
      if (this.status === 2 && this.enrollStatus != null) return this.enrollStatusClass
      if (this.status === 3 || this.status === 5) return 'status-fail'
      if (this.status === 0 || this.status === 1) return 'status-pending'
      if (this.status === 2) return 'status-pass'
      return ''
    },
    enrollStatusText() {
      if (this.enrollStatus == null) return '—'
      const key = String(this.enrollStatus)
      return degreeThesisEnrollStatus[key] != null ? degreeThesisEnrollStatus[key] : key
    },
    enrollStatusClass() {
      if (this.enrollStatus === 1 || this.enrollStatus === 5) return 'status-fail'
      if (this.enrollStatus === 0 || this.enrollStatus === 4) return 'status-pending'
      if (this.enrollStatus === 2) return 'status-pass'
      return ''
    },
    showAcademicReviewBtn() {
      // 仅论文不通过可申请学术复核；资料不通过则流程结束；须处于学术复核时间内
      if (this.status === 5 || this.academicReview) return false
      if (this.enrollStatus !== 5) return false
      return this.isInAcademicReviewTime
    },
    eflTypeText() {
      const t = this.detail.eflType
      if (!t && t !== 0) return '—'
      return degreeEflType[String(t)] || t
    },
    plagiarismRateText() {
      const r = this.detail.plagiarismRate
      if (r === null || r === undefined || r === '') return '—'
      const s = String(r)
      return s.indexOf('%') >= 0 ? s : `${s}%`
    },
  },
  created() {
    this.batchId = this.$route.query.batchId || ''
    this.initPage()
  },
  watch: {
    '$route.query.batchId'(batchId) {
      if (batchId && batchId !== this.batchId) {
        this.batchId = batchId
        this.loadDetail()
      }
    },
  },
  methods: {
    async initPage() {
      await this.loadBatches()
      await this.loadDetail()
    },
    async loadBatches() {
      const res = await this.$http.post('/student/degree/myThesis', {
        thesisBatchId: this.batchId || '',
      })
      if (res && res.configs && res.configs.length) {
        this.batchOptions = res.configs.map((c) => this.mapBatch(c))
        if (!this.batchId) this.batchId = res.defaultThesisBatchId || this.batchOptions[0].id
        this.currentBatch =
          this.batchOptions.find((b) => b.id === this.batchId) || this.batchOptions[0]
        if (res.thesis) {
          this.enrollId = res.thesis.thesisDegreeEnrollId || res.thesis.id || ''
        }
      } else if (res && res.config) {
        this.batchOptions = [this.mapBatch(res.config)]
        if (!this.batchId) this.batchId = res.config.id
        this.currentBatch = this.batchOptions[0]
        if (res.thesis) {
          this.enrollId = res.thesis.thesisDegreeEnrollId || res.thesis.id || ''
        }
      }
    },
    pickTime(obj, camel, snake) {
      if (!obj) return ''
      return obj[camel] || obj[snake] || ''
    },
    mapBatch(c) {
      return {
        id: c.id,
        name: c.name,
        applyStartTime: this.pickTime(c, 'applyStartTime', 'apply_start_time'),
        applyEndTime: this.pickTime(c, 'applyEndTime', 'apply_end_time'),
        firstReviewResubmitEnd: this.pickTime(c, 'firstReviewResubmitEnd', 'first_review_resubmit_end'),
        finalReviewResubmitEnd: this.pickTime(c, 'finalReviewResubmitEnd', 'final_review_resubmit_end'),
        thesisResubmitEnd: this.pickTime(c, 'thesisResubmitEnd', 'thesis_resubmit_end'),
        resultOpenTime: this.pickTime(c, 'resultOpenTime', 'result_open_time'),
        academicReviewStart: this.pickTime(c, 'academicReviewStart', 'academic_review_start'),
        academicReviewEnd: this.pickTime(c, 'academicReviewEnd', 'academic_review_end'),
      }
    },
    ensureCanApplyAcademicReview() {
      if (!this.isInAcademicReviewTime) {
        this.$message.warning(
          `学术复核时间为：${this.academicReviewTimeText}，当前不在申请时间范围内`
        )
        return false
      }
      return true
    },
    async loadDetail() {
      try {
        const res = await this.$http.get('/student/thesis/degree/application/detail', {
          thesisBatchId: this.batchId,
        })
        if (res && (res.id || res.examAvgScore || res.thesisTitle || res.studentStatusProofUrl)) {
          this.detail = {
            examAvgScore: res.examAvgScore,
            studentStatusProofUrl: res.studentStatusProofUrl,
            studentStatusProofName: res.studentStatusProofName,
            eflSource: res.eflSource != null ? Number(res.eflSource) : 1,
            eflType: res.eflType,
            eflScore: res.eflScore,
            eflExamDate: res.eflExamDate,
            eflCertificateNo: res.eflCertificateNo,
            eflExamAddress: res.eflExamAddress,
            achievementProofUrl: res.achievementProofUrl,
            achievementProofName: res.achievementProofName,
            thesisTitle: res.thesisTitle || res.thesisDegreeName,
            plagiarismRate: res.plagiarismRate,
            thesisManuscriptUrl: res.thesisManuscriptUrl || res.thesisDegreeUrl,
            thesisManuscriptName: res.thesisManuscriptName || res.thesisDegreeFileName,
            plagiarismReportUrl: res.plagiarismReportUrl,
            plagiarismReportName: res.plagiarismReportName,
            otherAttachmentUrl: res.otherAttachmentUrl,
            otherAttachmentName: res.otherAttachmentName,
            electronicPhotoUrl: res.electronicPhotoUrl,
            electronicPhotoName: res.electronicPhotoName,
          }
          // 资料审核状态
          if (res.status != null) this.status = Number(res.status)
          else if (res.applicationStatus != null) this.status = Number(res.applicationStatus)
          else this.status = null

          // 论文审核状态
          this.enrollStatus = res.enrollStatus != null ? Number(res.enrollStatus) : null

          // 最终结论：1-通过 0-不通过（优先接口 degreeApplyStatus）
          if (res.degreeApplyStatus != null && res.degreeApplyStatus !== '') {
            this.degreeApplyResult = Number(res.degreeApplyStatus)
          } else if (this.enrollStatus === 2) {
            this.degreeApplyResult = 1
          } else if (this.status === 5 || this.enrollStatus === 5) {
            this.degreeApplyResult = 0
          } else {
            this.degreeApplyResult = null
          }

          // 暂不通过 / 论文打回修改：直接进入填写页修改后重新提交
          if (this.status === 3 || this.enrollStatus === 1) {
            this.$router.replace({
              path: '/main/degreeApply',
              query: { batchId: this.batchId },
            })
            return
          }

          if (res.academicReview) {
            this.academicReview = res.academicReview
          } else {
            this.academicReview = null
          }
          if (res.enrollId || res.thesisDegreeEnrollId) {
            this.enrollId = res.enrollId || res.thesisDegreeEnrollId
          }
          await this.loadLogs()
        } else {
          this.$router.replace({
            path: '/main/degreeApply',
            query: { batchId: this.batchId },
          })
        }
      } catch (e) {
        this.$router.replace({
          path: '/main/degreeApply',
          query: { batchId: this.batchId },
        })
      }
    },
    async loadLogs() {
      if (!this.enrollId) return
      try {
        const res = await this.$http.get('/student/degree/log/detail/' + this.enrollId)
        if (res && res.logs) {
          this.logs = res.logs
        }
      } catch (e) {
        // ignore
      }
    },
    onBatchChange() {
      this.currentBatch =
        this.batchOptions.find((b) => b.id === this.batchId) || null
      this.academicReview = null
      this.logs = []
      this.detail = {}
      this.status = null
      this.enrollStatus = null
      this.degreeApplyResult = null
      this.loadDetail()
    },
    getAfterStatus(item) {
      return item.afterStatus != null ? item.afterStatus : item.status
    },
    /** 按日志 operType 取对应状态枚举，避免数字码冲突 */
    getLogStatusMap(item) {
      const type = item && item.operType
      if (type === 'thesisReview') return degreeThesisEnrollStatus
      if (type === 'academicReview') return degreeAcademicReviewStatus
      if (type === 'setDegreeApplyStatus') return degreeApplyFinalStatus
      return degreeApplyStatus
    },
    getStatusLabel(status, item) {
      if (status == null || status === '') return '—'
      const map = this.getLogStatusMap(item)
      const key = String(status)
      return map[key] != null ? map[key] : key
    },
    getStatusClass(status, item) {
      const text = this.getStatusLabel(status, item)
      if (text === '暂不通过' || text === '不通过' || text === '打回修改') return 'status-fail'
      if (text === '通过' || text === '已复核') return 'status-pass'
      if (text === '待初审') return 'status-initial'
      if (
        text === '待终审' ||
        text === '待论文评审' ||
        text === '待资格通过' ||
        text === '待复核'
      ) {
        return 'status-pending'
      }
      return ''
    },
    /** 存在 before/after 且发生变更时，展示「前状态 → 后状态」 */
    hasStatusChange(item) {
      if (item.beforeStatus == null || item.beforeStatus === '') return false
      const after = this.getAfterStatus(item)
      if (after == null || after === '') return false
      return Number(item.beforeStatus) !== Number(after)
    },
    getLogStatusText(item) {
      const after = this.getAfterStatus(item)
      const label = this.getStatusLabel(after, item)
      if (label && label !== '—' && label !== String(after)) return label
      if (item.statusText) return item.statusText
      return label
    },
    getLogStatusClass(item) {
      const cls = this.getStatusClass(this.getAfterStatus(item), item)
      if (cls) return cls
      const text = this.getLogStatusText(item)
      if (text === '暂不通过' || text === '不通过' || text === '打回修改') return 'status-fail'
      if (text === '待初审') return 'status-initial'
      if (
        text === '待终审' ||
        text === '待论文评审' ||
        text === '待资格通过' ||
        text === '待复核'
      ) {
        return 'status-pending'
      }
      if (text === '通过' || text === '已复核') return 'status-pass'
      return ''
    },
    openReviewDialog() {
      if (!this.ensureCanApplyAcademicReview()) return
      if (this.academicReview) {
        this.reviewForm = {
          fileUrl: this.academicReview.studentApplyFormUrl || '',
          fileName: this.academicReview.studentApplyFormName || '',
        }
      }
      this.reviewDialogVisible = true
    },
    resetReviewForm() {
      this.reviewForm = { fileUrl: '', fileName: '' }
    },
    onReviewImageSuccess(e) {
      this.reviewForm.fileUrl = e.url || ''
      this.reviewForm.fileName = e.name || ''
    },
    downloadTemplate() {
      const fileName = '西南科技大学学历继续教育学位复核申请书.docx'
      const a = document.createElement('a')
      a.href = `${process.env.BASE_URL}templates/${encodeURIComponent(fileName)}`
      a.download = fileName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    submitReview() {
      if (!this.ensureCanApplyAcademicReview()) return
      if (!this.reviewForm.fileUrl) {
        this.$message.warning('请上传学术复核申请表扫描件')
        return
      }
      if (!this.enrollId) {
        this.$message.warning('缺少报名信息，无法提交学术复核')
        return
      }
      this.reviewSubmitting = true
      const params = {
        batchId: this.batchId,
        enrollId: this.enrollId,
        studentApplyFormUrl: this.reviewForm.fileUrl,
        studentApplyFormName: this.reviewForm.fileName,
      }

      this.$http
        .post('/student/thesis/degree/academicReview/submit', params)
        .then(() => {
          this.academicReview = {
            submitTime: this.formatDateTime(new Date()),
            studentApplyFormUrl: this.reviewForm.fileUrl,
            studentApplyFormName: this.reviewForm.fileName,
            teacherDecisionUrl: '',
            teacherDecisionName: '',
          }
          this.logs.unshift({
            createTime: this.formatDateTime(new Date()),
            operatorName: (this.$store.state.user && this.$store.state.user.name) || '—',
            operatorRole: 'student',
            operType: 'academicReview',
            afterStatus: 0,
            operDesc: '已提交学术复核申请',
          })
          this.$message.success('学术复核申请已提交')
          this.reviewDialogVisible = false
        })
        .finally(() => {
          this.reviewSubmitting = false
        })
    },
    formatDateTime(date) {
      const pad = (n) => (n < 10 ? '0' + n : n)
      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        ' ' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds())
      )
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/variable.scss";

.degree-apply-result {
  min-height: 500px;

  ::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}

.page-header {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  height: 72px;
  line-height: 72px;
}

.page-header-line {
  width: 4px;
  height: 22px;
  background-color: $primary;
  border-radius: 2px;
  margin-right: 10px;
  flex-shrink: 0;
}

.page-header h5 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0;
  line-height: 60px;
}

.page-body {
  background-color: #fff;
  border-radius: 5px;
  padding: 20px 24px 32px;
}

.batch-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
}

.batch-item {
  display: flex;
  align-items: center;
}

.batch-select {
  width: 280px;
  max-width: 100%;
}

.batch-time {
  margin-left: auto;
}

.field-label {
  color: #333;
  font-size: 14px;
  white-space: nowrap;
}

.field-value {
  color: #333;
  font-size: 14px;
}

.status-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 16px;
  gap: 8px;
}

.time-tip {
  margin-top: 10px;
  color: #e6a23c;
  font-size: 13px;
  line-height: 20px;
}

.enroll-status-label {
  margin-left: 24px;
}

.status-text {
  font-size: 14px;
  font-weight: 500;
}

.status-initial{
  color: #909399;
}

.status-pass {
  color: #13c2c2;
}

.status-pending {
  color: #ff8a00 !important;
}

.status-fail {
  color: #f56c6c;
}

.review-btn {
  margin-left: 12px;
}

.divider {
  height: 1px;
  background-color: #e8e8e8;
  margin: 18px 0 20px;
}

.section-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin: 8px 0 12px;
}

.info-card {
  background: #f7f9fc;
  border-radius: 5px;
  padding: 18px 20px;
  margin-bottom: 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 40px;
  row-gap: 14px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  min-width: 0;
}

.info-item-full {
  grid-column: 1 / -1;
}

.info-label {
  color: #767676;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  flex-shrink: 0;
}

.info-value {
  color: #1a1a1a;
  font-size: 14px;
  line-height: 22px;
  word-break: break-all;
}

.file-link {
  color: $primary;
  font-size: 14px;
  line-height: 22px;
  text-decoration: underline;
  cursor: pointer;
  word-break: break-all;
}

/* 日志时间线 */
.audit-timeline {
  position: relative;
}

.audit-timeline-item {
  position: relative;
  padding-left: 32px;
}

.audit-timeline-item + .audit-timeline-item {
  margin-top: 12px;
}

.audit-timeline-line {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 1px;
  height: calc(100% + 12px);
  background: $primary;
}

.timeline-dot {
  position: absolute;
  left: 0;
  top: 40px;
  width: 10px;
  height: 10px;
  border: 1px solid $primary;
  border-radius: 50%;
  background: #fff;
  box-sizing: border-box;
  z-index: 1;
}

.timeline-dot::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 4px;
  height: 4px;
  background: $primary;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.audit-log-card {
  width: 100%;
  min-height: 90px;
  padding: 18px 20px 14px;
  box-sizing: border-box;
  background: #f7f9fc;
  border-radius: 5px;
}

.audit-log-header {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  column-gap: 20px;
  align-items: center;
}

.audit-field {
  display: flex;
  align-items: center;
}

.audit-label {
  color: #767676;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
}

.audit-value {
  color: #1a1a1a;
  font-size: 14px;
  line-height: 20px;
}

.audit-status-wrap {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
}

.audit-status {
  font-size: 13px;
  line-height: 20px;
}

.audit-status-arrow {
  color: #999;
  font-size: 13px;
  line-height: 20px;
  margin: 0 2px;
}

.audit-status.status-pass,
.audit-status.status-pending,
.audit-status.status-fail {
  padding: 0 6px;
  border-radius: 2px;
}

.audit-status.status-pass {
  background: rgba(19, 194, 194, 0.1);
}

.audit-status.status-pending {
  background: rgba(255, 138, 0, 0.1);
}

.audit-status.status-fail {
  background: rgba(245, 108, 108, 0.1);
}

.audit-log-remark {
  margin-top: 10px;
  line-height: 20px;
}

.empty-log {
  color: #999;
  font-size: 14px;
  padding: 12px 0;
}

.review-dialog-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  padding: 8px 0 4px;
  box-sizing: border-box;
}

.review-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 24px;
  gap: 4px;
}

.review-row:last-of-type {
  margin-bottom: 0;
}

.review-label {
  color: #333;
  font-size: 14px;
  line-height: 32px;
  white-space: nowrap;
  flex-shrink: 0;
}

.review-label.required::before {
  content: "*";
  color: #f56c6c;
  margin-right: 2px;
}

.review-file-name {
  display: block;
  margin-top: 12px;
  max-width: 100%;
  word-break: break-all;
}

.dialog-footer {
  text-align: center;

  .el-button + .el-button {
    margin-left: 16px;
  }

  ::v-deep .review-btn-cancel {
    color: $primary;
    border-color: $primary;
    background: #fff;

    &:hover,
    &:focus {
      color: $primary-dark;
      border-color: $primary-dark;
      background: $primary-light;
    }
  }
}

@media (max-width: 768px) {
  .batch-time {
    margin-left: 0;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .audit-log-header {
    grid-template-columns: 1fr;
    row-gap: 8px;
  }
}
</style>

<style lang="scss">
@import "@/variable.scss";

.academic-review-dialog {
  border-radius: 4px;

  .el-dialog__header {
    padding: 10px 20px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__title {
    font-size: 16px;
  }

  .el-dialog__headerbtn {
    top: 18px;
  }

  .el-dialog__body {
    padding: 28px 24px 20px;
  }

  .el-dialog__footer {
    padding: 12px 20px 20px;
    border-top: 1px solid #ebeef5;
    text-align: center;
  }

  .dialog-footer .el-button {
    min-width: 80px;
  }

  .dialog-footer .review-btn-cancel {
    color: $primary;
    border-color: $primary;
    background: #fff;

    &:hover,
    &:focus {
      color: $primary-dark;
      border-color: $primary-dark;
      background: $primary-light;
    }
  }
}

.upload-tip {
  font-size: 13px;
  color: #999;
  line-height: 20px;
  margin-left: 10px;
}
</style>
